<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div v-if="permission.access">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <!-- :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" -->
            <v-select
              @on-change="paginateChange"
              :options="perPageOptions"
              v-model="search.paginate"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="search.search_data"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="getToCreate">
                <span class="text-nowrap">Add Teacher</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="text-center align-middle">SL</th>
              <th class="align-middle">Name</th>
              <th class="align-middle text-center">Type</th>
              <th class="align-middle text-center">Status</th>
              <th class="align-middle text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(teacher, index) in teachers.data"
              :key="index"
              v-if="teachers.data.length"
            >
              <td class="text-center align-middle">
                {{ teachers.from + index }}
              </td>
              <td class="align-middle">
                <p class="mb-0 pb-0">
                  <b>{{ teacher.name }}</b>
                </p>
              </td>
              <td class="align-middle text-center">
                <b-badge
                  :variant="teacher.is_head == 1 ? 'info' : 'primary'"
                  class="text-capitalize"
                >
                  {{ teacher.is_head == 1 ? "Department Head" : "Faculty" }}
                </b-badge>
              </td>
              <td class="align-middle text-center">
                <b-badge
                  :variant="teacher.status == 1 ? 'success' : 'danger'"
                  class="text-capitalize"
                >
                  {{ teacher.status == 1 ? "Active" : "Inactive" }}
                </b-badge>
              </td>
              <td class="text-center align-middle">
                <b-button
                  variant="primary"
                  @click="goToEdit(teacher.id)"
                  :disabled="!permission.edit"
                  class="btn-sm"
                >
                  <span class="text-nowrap">Edit</span>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ teachers.from }} to {{ teachers.to }} of
              {{ teachers.total }} entries</span
            >
          </b-col>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <pagination
              :data="teachers"
              @pagination-change-page="getResults"
              align="right"
              :show-disabled="true"
              :limit="5"
            ></pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BButton, BBadge } from "bootstrap-vue";
import vSelect from "vue-select";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BBadge,
    vSelect,
  },
  data() {
    return {
      search: {
        search_data: "",
        paginate: 10,
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100],

      teachers: {},
      permission: {
        access: false,
        create: false,
        edit: false,
        delete: false,
      },
    };
  },
  mounted() {
    this.getResults();
    this.Permission();
  },
  methods: {
    getToCreate() {
      this.$router.push("/teacher/create");
    },
    goToEdit(id) {
      this.$router.push("/teacher/edit/" + id);
    },
    async getResults(page) {
      this.search.page = page == null ? this.search.page : page;
      const teachers = await this.callApi(
        "post",
        "/app/teacher?page=" + this.search.page,
        this.search
      );
      if (teachers.status == 200) {
        this.teachers = teachers.data.teachers;
      }
    },

    // Paginate Data Gate
    paginateChange() {
      this.search.page = 1;
      this.getResults();
    },

    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "teacher.access") {
          this.permission.access = true;
        }

        if (permission.slug == "teacher.create") {
          this.permission.create = true;
        }

        if (permission.slug == "teacher.edit") {
          this.permission.edit = true;
        }

        if (permission.slug == "teacher.destroy") {
          this.permission.delete = true;
        }
      });
    },
  },
  watch: {
    "search.paginate": function (val) {
      this.paginateChange();
    },
  },
};
</script>

<style></style>
